import hoverDark from '../hover/dark';

const dark = (params) => hoverDark(params);

export default dark;
